import CmSitesContainer from '@components/containers/cmSites';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

/**
 * Wrapped in AppLayout like every other brand screen.
 *
 * The layout is applied per page rather than by the router, so a shell that forgets it renders
 * the container correctly and loses the whole navigation — which reads as the app breaking
 * rather than as one page being mis-wired.
 */
const CmSites: FC = () => (
    <AppLayout>
        <CmSitesContainer />
    </AppLayout>
);

export default CmSites;
